import { render, staticRenderFns } from "./UserDataHistory.vue?vue&type=template&id=052fe192&scoped=true"
import script from "./UserDataHistory.vue?vue&type=script&lang=js"
export * from "./UserDataHistory.vue?vue&type=script&lang=js"
import style0 from "./UserDataHistory.vue?vue&type=style&index=0&id=052fe192&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052fe192",
  null
  
)

export default component.exports